import tooltipStyles from "./tooltip.module.css";
import React from "react";

function Tooltip({
  children,
  isShown,
  position,
  variant,
  className,
}: {
  children: React.ReactNode;
  isShown: boolean;
  position?: string;
  variant?: "toggle" | "default";
  className?: string;
}) {
  return (
    <span
      className={`${tooltipStyles.tooltip} 
        ${position === "center" ? tooltipStyles.tooltip_position_center : ""}
        ${position === "bottom" ? tooltipStyles.tooltip_position_bottom : ""}
        ${position === "right" ? tooltipStyles.tooltip_position_right : ""}
        ${isShown ? tooltipStyles.tooltip_visible : ""}
        ${variant === "toggle" ? tooltipStyles.tooltip_toggle_center : ""} 
        ${className ? className : ""} 
      `}
    >
      {children}
    </span>
  );
}

export default Tooltip;
